export const STORY_PRIORITIES=Object.freeze([
  {value:'',label:'No priority'},
  {value:'must',label:'Must use'},
  {value:'maybe',label:'Maybe'},
  {value:'avoid',label:'Avoid'}
]);
// A quick, repeatable decision on each Assembly slip; never removes footage.
export function nextStoryPriority(current=''){
  const index=STORY_PRIORITIES.findIndex(item=>item.value===current);
  return STORY_PRIORITIES[(index<0?1:index+1)%STORY_PRIORITIES.length].value;
}
export function setStoryPriority(paper,blockId,priority){
  if(!STORY_PRIORITIES.some(item=>item.value===priority))throw new Error('Invalid editorial priority.');
  if(!paper.blocks.some(block=>block.id===blockId))return paper;
  return {...paper,blocks:paper.blocks.map(block=>block.id===blockId
    ? {...block,...(priority?{priority}:{priority:undefined})}:block)};
}
export function storyPriorityLabel(priority){
  return STORY_PRIORITIES.find(item=>item.value===priority)?.label||'';
}

export function markSourceWords(paper,source,selectedIds,priority,id=()=>crypto.randomUUID()){
  if(!STORY_PRIORITIES.some(item=>item.value===priority))throw new Error('Invalid editorial priority.');
  const ids=new Set(selectedIds);
  const indices=source.words.map((word,i)=>ids.has(word.id)?i:-1).filter(i=>i>=0);
  if(!indices.length)return paper;
  const groups=[];
  for(const index of indices){
    const last=groups.at(-1);
    if(last&&index===last.end+1)last.end=index;
    else groups.push({start:index,end:index});
  }
  const existing=(paper.editorialTags||[]).filter(tag=>!(tag.sourceId===source.id &&
    groups.some(group=>tag.start<=group.end&&tag.end>=group.start)));
  return {...paper,editorialTags:[...existing,...(priority?groups.map(group=>({
    id:id(),sourceId:source.id,start:group.start,end:group.end,priority,
    firstWordId:source.words[group.start].id,lastWordId:source.words[group.end].id
  })):[])]};
}
export function sourceWordPriority(paper,source){
  const result={};
  for(const tag of paper.editorialTags||[]){
    if(tag.sourceId!==source.id||source.words[tag.start]?.id!==tag.firstWordId||
      source.words[tag.end]?.id!==tag.lastWordId)continue;
    for(let i=tag.start;i<=tag.end&&i<source.words.length;i++){
      const word=source.words[i];if(word)result[word.id]=tag.priority;
    }
  }
  return result;
}
